/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import PropTypes from 'prop-types';
import { ProgressBar } from '@carbon/react';

import * as Styled from './ProjectsDropdown.styled';

const ProjectsDropdown = ({
  selectedProject,
  createProjectSelected,
  isCreatingProject,
  isPublishing,
  hasProjects,
  filteredProjects,
  onCreateNewProject,
  onProjectSelected
}) => {
  if (isCreatingProject || isPublishing) {
    const label = isCreatingProject ? 'Creating project' : 'Adding resources to project';
    return <ProgressBar label={label} />;
  }

  return (
    <Styled.ProjectsDropdown
      id="select-project"
      data-test="select-project"
      label={createProjectSelected ? 'Create new project' : 'Select a project'}
      selectedItem={selectedProject?.name || ''}
      titleText=""
      items={[
        { id: 'create-project', name: 'Create new project' },
        ...(hasProjects
          ? filteredProjects
          : [
              {
                id: 'no-projects',
                name: 'No projects have been created yet',
                disabled: true
              }
            ])
      ]}
      itemToElement={(item) => {
        // @ts-expect-error TS2339
        return item.id === 'create-project' ? (
          // @ts-expect-error TS2339
          <Styled.CreateNewProjectItem data-test={item.id}>{item.name}</Styled.CreateNewProjectItem>
        ) : (
          // @ts-expect-error TS2339
          item.name
        );
      }}
      onChange={({ selectedItem }) => {
        // @ts-expect-error TS2339
        if (selectedItem.id === 'create-project') {
          onCreateNewProject();
        } else {
          onProjectSelected(selectedItem);
        }
      }}
    />
  );
};

ProjectsDropdown.propTypes = {
  selectedProject: PropTypes.object,
  isCreatingProject: PropTypes.bool,
  isPublishing: PropTypes.bool,
  hasProjects: PropTypes.bool,
  filteredProjects: PropTypes.array,
  onCreateNewProject: PropTypes.func,
  onProjectSelected: PropTypes.func
};

export default ProjectsDropdown;
